










import Vue from 'vue';
import Component from 'vue-class-component';
import SiteHeader from './views/Layout/SiteHeader.vue';
import SiteFooter from './views/Layout/SiteFooter.vue';

@Component({
	components: {
		SiteHeader,
		SiteFooter,
	},
})
export default class App extends Vue {}
